import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGOrganizationsService } from '../../../shared/API-Service/services/ngorganizations.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../app/shared/components/base/base.component'

@Component({
  selector: 'app-ngorganizations',
  templateUrl: './ngorganizations.component.html',
  styleUrls: ['./ngorganizations.component.css']
})
export class NGOrganizationsComponent extends BaseComponent implements OnInit {
  NGOrganizations: any;

  constructor(private NGOrganizationsService:NGOrganizationsService,private _Router:Router) { super()}

  ngOnInit(): void {
    this.getNGOrganizations();
    
  }
 
  pageChanged(event: any) {
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
    this.getNGOrganizations();

  }
  getNGOrganizations(){
 
    this.NGOrganizationsService.GetNGOrganizationsPaged(this.pager).subscribe((res) => {
      this.NGOrganizations = res.data.items
      this.totalCount=res.data.totalCount;
    console.log(this.NGOrganizations);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  GotoDetails(item){
    this._Router.navigate(['/content/admin/NGOrganizationsDetails',item.id]);
  }
  // update(id){
  //   console.log(id);
  //   //this.PartnersService.Data.next(data);
  //   // this._Router.navigate(['/content/admin/insert-partner']);
  //   this._Router.navigate(['/content/admin/update-partner',id]);
  //   }

    // delete(id : number){
    //   Swal.fire({
    //     title: 'هل تريد مسح العنصر ؟',
    //     text: "لن يكون لك صلاحية إعادته مره اخرى",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     cancelButtonText: 'الغاء',
    //     confirmButtonText: 'امسح العنصر !'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.PartnersService.DeletePartner(id).subscribe((res) => {
    //         Swal.fire({
    //           icon: "success",
    //           title: "تم المسح بنجاح",
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //      this.getSuppliers();
    //       },(err) => {
    //         Swal.fire({
    //           icon: 'error',
    //           title: 'خطأ',
    //           text:err.error.message    
    //         })
    //       },() => {
    //         console.log("completed");
    //       })
    //     }
    //   }) 
    // }


}
